const Index = '/external';
const ApiDocs = Index + '/apidocs';
const Redoc = Index + '/redoc';

export const StaticRoutes = {
    ApiDocs,
    Redoc,
};

export const DynamicRoutes = {};

export const routes = [
    {
        url: ApiDocs,
        name: 'apidocs',
        component: 'Swagger',
        exact: false,
    },
    {
        url: Redoc,
        name: 'redoc',
        component: 'Redoc',
        exact: false,
    }
];

const combined = {StaticRoutes, DynamicRoutes, routes};

export default combined;
